import React, { Component } from 'react';  
import LinearGradient from 'react-native-web-linear-gradient';
import { StyleSheet, Text, View, TouchableOpacity, Animated, AsyncStorage, I18nManager as RNI18nManager } from 'react-native';  
import { Ionicons } from "@expo/vector-icons";
import { Feather } from '@expo/vector-icons';
import store from "../config/config.json"
import i18n from 'i18n-js';
import { EventRegister } from 'react-native-event-listeners'

export default class TopBar extends Component {  

    state = {
        store : {},
        isShowing: false,
        opacity : new Animated.Value(0)
    }

    constructor(props){
        super(props)
        this.getData()
    }

    getData = async () => {
		try {

			var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
                value = JSON.parse(value)	
            
            this.setState({store: value})
            
        } catch (error) {
            console.log(error)
        }
    }        

	openMenu(){
		this.props.changeState({showMenu: true});
    }
    
    onLoad = () => {
        this.setState({isShowing: true})
        Animated.timing(this.state.opacity, {
                toValue: 1,
                duration: 150,
                useNativeDriver: true
        }).start()
    }

    onHide = () => {
        this.setState({isShowing: false})
        Animated.timing(this.state.opacity, {
                toValue: 0,
                duration: 150,
                useNativeDriver: true
        }).start()
    }

    reviewOrder(){
		this.props.changeState({openOrder: true});
    }
    
    changeLanguage()
    {
        if(i18n.locale == this.state.store.defaultLanguage)
            i18n.locale = this.state.store.secLanguage
        else
            i18n.locale = this.state.store.defaultLanguage

        if(i18n.locale == 'ar')
        {
            RNI18nManager.forceRTL(true);
        } 
        else
        {
            RNI18nManager.forceRTL(false);
        }   

        this.setState({store: this.state.store})
        EventRegister.emit('languageEvent', 'it works!!!')        
        //Updates.reloadFromCache();
    }
   // <LinearGradient style={styles.topBar} colors={this.props.scrollOffset <= 0 ? ['rgba(0,0,0,1)', 'transparent'] : ['white', 'white']} >

    render() {  

        var mainTitle = ""
        let offsetCount = 200

        if(this.props.scrollOffset > offsetCount && !this.state.isShowing){
            this.onLoad()
        }else if(this.props.scrollOffset < offsetCount && this.state.isShowing){
            this.onHide()
        }

        var iconColor = 'black' // 'white'
        if(this.props.scrollOffset > 5){
            iconColor = 'black'
        } 

        if (this.props.topBarData != undefined){
            if(!this.props.topBarData.isScrollable){
                iconColor = 'black'
                mainTitle = this.props.topBarData.title
            }
        }

        var textLang = this.state.store.defaultLanguage
        if(i18n.locale == this.state.store.defaultLanguage)
            textLang = this.state.store.secLanguage

        if(textLang == undefined)
            textLang = ""
        else
            textLang = textLang.toUpperCase()
        
        return (  
            <View style={styles.topBar}>
                
                <LinearGradient style={styles.topBar} colors={this.props.scrollOffset <= 0 ? ['white', 'white'] : ['white', 'white']} >
                    {!this.props.showFullMode && (
                        <TouchableOpacity style={[styles.button], {marginLeft: 15}}
                            onPress={() => { this.openMenu() }}
                        >
                            <Ionicons name="ios-menu" size={24} color={iconColor} />

                        </TouchableOpacity>
                    )}
                    
                    <View style={{flex: 1, position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
                        {mainTitle == '' &&(
                             <Animated.Image  
                             source={this.state.store.logoUrl} 
                             style={[styles.button, {
                                 opacity: this.state.opacity,
                                 transform: [{
                                     scale: this.state.opacity.interpolate({
                                         inputRange: [0, 1],
                                         outputRange: [0.1, 1],
                                     })
                                 }]
                             }]}/>
                        )}

                        { mainTitle != '' &&(
                            <Text style={{color: iconColor, fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t(mainTitle.toLowerCase())}</Text>															
                        )}
                    </View>
                    
                        
                    <View style={{marginLeft: "auto", flexDirection: "row"}}>
                                            
                        <TouchableOpacity style={styles.button}
                            onPress={() => { this.reviewOrder() }}
                        >
                            <Feather name="shopping-bag" size={22} color={iconColor} />
                            {this.props.showCart && (<View style={{position:"absolute", marginTop: 10, marginLeft: 10, backgroundColor: "red", width: 20, height: 20, position: "absolute", borderRadius: 10, alignItems: "center", alignContent: "center", justifyContent: "center"}}>
                                <Text style={{color: "white", textAlign: "center", fontSize: 11}}>{this.props.orderCount}</Text>															
                            </View> )}							
                        </TouchableOpacity>
                        
                        {this.state.store.secLanguage != undefined && this.state.store.secLanguage != 'none' && !this.props.showFullMode && (
                            <TouchableOpacity style={styles.button}
                                onPress={() => { this.changeLanguage() }}
                            >
                                <Text style={{fontFamily:"main-bold", textAlign: "center", color: iconColor, fontSize: 16}}>{textLang}</Text>															
                            </TouchableOpacity>
                        )}		
                        <View style={{marginLeft: 5, marginRight:5}} />
                        
                    </View>

                </LinearGradient>
            </View>     
        );  
    }  
}  
  
const styles = StyleSheet.create({  
    topBar: {
        position: "absolute",
        width: "100%", 
        height: 50,
        flexDirection: "row", 
        justifyContent: "center", 
        alignContent: "center", 
        alignItems: "center"
    },
    button:{
        height:40, 
        width: 40, 
        justifyContent: "center"
    }
})  